<div class="metrics-grid">
  <div *ngFor="let card of cards" class="metric-card-wrapper">
    <div class="metric-box">
      <div class="metric-info">
        <span class="metric-label">{{ card.label }}</span>
        <span class="metric-value">{{ card.value }}</span>
        <span class="metric-description">{{ card.description }}</span>
      </div>

      <div class="metric-icon" [style.background-color]="card.color">
        <i [class]="card.icon"></i>
      </div>
    </div>
  </div>
</div>
